module.exports = __webpack_public_path__ + "static/media/home_new.3d09964c.jpeg";